import React, { useEffect } from "react";
import FormWarning from "./FormWarning";
import CustomInput from "../../../common/components/CustomInput/CustomInput.jsx";

const EasyOpenInput = props => {
  const { propName } = props;
  const setPropMounted = props.connectForm.setPropMounted;

  // const warningStyles = {
  //   warning: {
  //     color: "red",
  //     display: "flex",
  //     justifyContent: "end",
  //     marginTop: "-8px",
  //     fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
  //     fontSize: "10px"
  //   }
  // }

  useEffect(() => {
    setPropMounted(propName, true);
    return () => {
      setPropMounted(propName, false);
    };
  }, [setPropMounted, propName]);

  const spreadIt = props.inputProps == null ? {} : props.inputProps;

  return (
    <div>
      <CustomInput
        success={props.connectForm.getState(propName) === "Success"}
        error={props.connectForm.getState(propName) === "Error"}
        labelText={
          <span>
            {props.connectForm.getLabel(propName) + " "}
            {props.connectForm.isRequired(propName) ? <span>*</span> : ""}
          </span>
        }
        id={propName}
        formControlProps={{
          fullWidth: true
        }}
        inputProps={{
          onChange: event =>
            props.connectForm.change(event.target.value, propName),
          value: props.connectForm.getValue(propName),
          autoComplete: "off",
          ...spreadIt
        }}
      />

      <FormWarning
        isValid={props.propName}
        isError={props.connectForm.getState(propName)}
        errorMessage={props.connectForm.getErrorMessage(propName)}
        fieldValue={props.connectForm.getValue(propName)}
      />
    </div>
  );
};

export default EasyOpenInput;
